// extracted by mini-css-extract-plugin
module.exports = {"hiddenLayout":"SlideText_hiddenLayout___U_Xp","hidden":"SlideText_hidden__mVq9q","normal":"SlideText_normal__ESD2R","loop":"SlideText_loop__3Sj6U"};